import { request } from "./request"

export const membersApi = {
  updateUserRole: (familyId: string, memberId: string, data: Record<string, any>) => {
    return request('PUT', `/api/2/family_cloud/families/${familyId}/members/${memberId}/role/`, data)
  },
}